import React, { useEffect, useState } from 'react'
import ImageBox from '../ImageBox/ImageBox'
import './LandingPopup.css'

const LandingPopup = ({close}) => {
    const [random, setrendom] = useState(null)
    useEffect(() => {
        function randomInteger(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
        }
        const num = randomInteger(1, 6)
        setrendom(num)
    }, [])
    
    return (
        <div className='landing-popup'>
            <div className="popup-box" style={{backgroundImage: `url(./img/left.webp)`}}>
                <div className="overlaybox">
                    <div className="close" title='close' onClick={close}>
                        <div className="button-span"></div>
                        <div className="button-span"></div>
                    </div>
                    <div className="popup-content">
                        <h4>Welcome to the party!<br /> Sign up to win over $2000 to spend your way with Elite Partyz suppliers!!</h4>
                    </div>
                    <div className="sponser">
                        {/* link should be dynamic */}
                        <ImageBox src={`./img/c${random}.jpg`} link="https://win.elitepartyz.com/melbourne-party-giveaway/" />
                    </div>
                    <div className="contest-navigation">
                        <a href="https://win.elitepartyz.com/melbourne-party-giveaway/">participate</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default LandingPopup